if (!customElements.get('delivery-urgency')) {
  customElements.define(
    'delivery-urgency',
    class DeliveryUrgency extends HTMLElement {
      connectedCallback() {
        this.cutoffHour = parseInt(this.dataset.cutoffHour) || 14;
        this.minDays = parseInt(this.dataset.minDays) || 3;
        this.maxDays = parseInt(this.dataset.maxDays) || 5;
        this.dateFormat = this.dataset.dateFormat || 'dd/MM';
        this.timeFormat = this.dataset.timeFormat || 'HH:MM:SS';
        this.template = this.dataset.template || '';
        this.timerColor = this.dataset.timerColor || '';
        this.contentEl = this.querySelector('.delivery-urgency__content');

        this.computeDates();
        this.tick();
        this.intervalId = setInterval(() => this.tick(), 1000);

        document.addEventListener('shopify:section:load', () => {
          clearInterval(this.intervalId);
          this.computeDates();
          this.tick();
          this.intervalId = setInterval(() => this.tick(), 1000);
        });
      }

      disconnectedCallback() {
        clearInterval(this.intervalId);
      }

      pad(n) {
        return String(n).padStart(2, '0');
      }

      getMonthName(monthIndex) {
        const months = [
          'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
          'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
        ];
        return months[monthIndex];
      }

      formatDate(date) {
        const dd = this.pad(date.getDate());
        const mm = this.pad(date.getMonth() + 1);

        if (this.dateFormat === 'MM/dd') return `${mm}/${dd}`;
        if (this.dateFormat === 'd mois') return `${date.getDate()} ${this.getMonthName(date.getMonth())}`;
        return `${dd}/${mm}`;
      }

      formatTimer(h, m, s) {
        if (this.timeFormat === 'Xh Xmin') {
          const hNum = parseInt(h, 10);
          const mNum = parseInt(m, 10);
          if (hNum > 0) return `${hNum} h ${this.pad(mNum)} min`;
          return `${mNum} min ${this.pad(parseInt(s, 10))} s`;
        }
        return `${h}:${m}:${s}`;
      }

      formatTimerPart(value, unit) {
        if (this.timeFormat === 'Xh Xmin') {
          const n = parseInt(value, 10);
          if (unit === 'h') return `${n} h`;
          if (unit === 'm') return `${n} min`;
          if (unit === 's') return `${n} s`;
        }
        return value;
      }

      addBusinessDays(startDate, days) {
        const result = new Date(startDate);
        let added = 0;
        while (added < days) {
          result.setDate(result.getDate() + 1);
          const dow = result.getDay();
          if (dow !== 0 && dow !== 6) added++;
        }
        return result;
      }

      computeDates() {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const baseDate = now.getHours() >= this.cutoffHour
          ? new Date(today.getTime() + 86400000)
          : today;

        this.dateMin = this.formatDate(this.addBusinessDays(baseDate, this.minDays));
        this.dateMax = this.formatDate(this.addBusinessDays(baseDate, this.maxDays));
      }

      tick() {
        const now = new Date();
        const cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), this.cutoffHour, 0, 0);

        let remaining;
        if (now >= cutoff) {
          const tomorrow = new Date(cutoff.getTime() + 86400000);
          remaining = Math.floor((tomorrow - now) / 1000);
        } else {
          remaining = Math.floor((cutoff - now) / 1000);
        }
        if (remaining < 0) remaining = 0;

        const h = this.pad(Math.floor(remaining / 3600));
        const m = this.pad(Math.floor((remaining % 3600) / 60));
        const s = this.pad(remaining % 60);

        const timerStyle = this.timerColor && this.timerColor !== 'rgba(0,0,0,0)'
          ? ` style="color:${this.timerColor}"`
          : '';

        const formattedTimer = this.formatTimer(h, m, s);

        // Build the rendered text from the template
        let output = this.template
          .replace(/\[timer\]/gi, `<strong class="delivery-urgency__timer"${timerStyle}>${formattedTimer}</strong>`)
          .replace(/\[date_min\]/gi, `<strong class="delivery-urgency__date"${timerStyle}>${this.dateMin}</strong>`)
          .replace(/\[date_max\]/gi, `<strong class="delivery-urgency__date"${timerStyle}>${this.dateMax}</strong>`)
          .replace(/\[heures\]/gi, `<strong class="delivery-urgency__timer"${timerStyle}>${this.formatTimerPart(h, 'h')}</strong>`)
          .replace(/\[minutes\]/gi, `<strong class="delivery-urgency__timer"${timerStyle}>${this.formatTimerPart(m, 'm')}</strong>`)
          .replace(/\[secondes\]/gi, `<strong class="delivery-urgency__timer"${timerStyle}>${this.formatTimerPart(s, 's')}</strong>`);

        this.contentEl.innerHTML = output;
      }
    }
  );
}
